import { render, staticRenderFns } from "./TitleAndDataProfiles.vue?vue&type=template&id=75fff9dc&"
import script from "./TitleAndDataProfiles.vue?vue&type=script&lang=js&"
export * from "./TitleAndDataProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports